export default __webpack_public_path__ + "media/images/images/backgrounds/mountain-116720d9acc788e52ef6deb0e3a849f2.png";